import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApplicationService } from 'src/app/shared/services/application.service';
import { SingleResultApiResponse } from 'src/app/shared/models/api-response.model';
import { Store, select } from '@ngrx/store';

@Component({
  selector: 'online-app-application-details',
  templateUrl: './application-details.component.html',
  styleUrls: ['./application-details.component.scss']
})
export class ApplicationDetailsComponent implements OnInit {

  applicationId: number;
  applicationNumber: string;

  SchoolProgramType: string;

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private store: Store<any>,
    private applicationService: ApplicationService) {

    this.applicationId = +this.activatedRoute.snapshot.params['id'];
  }

  ngOnInit() {

    this.applicationService.getApplicationDetails(this.applicationId)
      .subscribe((response: SingleResultApiResponse) => {
        if (response.Result) {
          this.applicationNumber = response.Result.ApplicationNumber;
          this.SchoolProgramType = response.Result.SchoolProgramType;
        }
      }, err => {
        console.error(err);
      });

    this.store.pipe(select('application'))
      .subscribe(applicationState => {

        if (applicationState &&
           (applicationState.schoolProgramChanged || this.isDraftStudyAroadApplication) &&
            this.applicationId > 0) {

          this.applicationService.getApplicationDetails(this.applicationId)
            .subscribe((response: SingleResultApiResponse) => {
              if (response.Result) {
                this.applicationNumber = response.Result.ApplicationNumber;
              }
            }, err => {
              console.error(err);
            });

        }

      });


  }

  //show border when tab on link for accessibility
  linkTabAccessibility(event): void {
    event.style.outline = "1px solid black";
  }

  linkBlurAccessibility(event): void {
    event.style.outline = "";
  }

  goBackToHome() {
    const userType = localStorage.getItem('userType');

    if (userType === 'agent') {
      this.router.navigate(['applications', 'agent-dashboard']);
    } else {
      this.router.navigate(['applications', 'dashboard']);
    }
  }


  get isDraftStudyAroadApplication(): boolean {
    return this.SchoolProgramType == 'StudyAbroad' && this.applicationNumber.startsWith("Z-");
  }
}
